<script setup>
import Wishlist from '@/components/basic/atoms/Wishlist.vue'
import { PAGE_URL } from '@/constants/GlobalConstants'
import { computed, defineAsyncComponent } from 'vue'

const VicampoLink = defineAsyncComponent(
  () => import('@/components/basic/atoms/VicampoLink.vue')
)

const wishlistUrl = computed(() => PAGE_URL.WISHLIST)
</script>

<template>
  <VicampoLink
    id="header-wishlist"
    :href="wishlistUrl"
    class="text-center d-flex align-center justify-center"
  >
    <Wishlist />
  </VicampoLink>
</template>
